import {
  Box,
  Button,
  Collapse,
  Icon,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { Transaction, TransactionItem } from "../../../../types/Product";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Replay,
} from "@mui/icons-material";
import { CalendarIcon } from "@mui/x-date-pickers";
import DateRangePicker from "./DateRangePicker";
import dayjs, { Dayjs } from "dayjs";
import { useTransaction } from "../../../../hooks/useTransaction";

const Row = (props: { row: Transaction }) => {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowUp fontSize="small" />
            ) : (
              <KeyboardArrowDown fontSize="small" />
            )}
          </IconButton>
        </TableCell>
        <TableCell>{dayjs(row.date).format("DD/MM/YYYY HH:mm:ss")}</TableCell>
        <TableCell align="right">{row.total}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {/* <Typography variant="subtitle1" gutterBottom component="div">
                詳情
              </Typography> */}
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>名稱</TableCell>
                    <TableCell>數量</TableCell>
                    <TableCell align="right">價格 ($)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.items.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.number}</TableCell>
                      <TableCell align="right">
                        {Math.round(item.number * item.price * 100) / 100}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

const TabTransaction = () => {
  const { transactions } = useTransaction();

  const [rows, setRows] = React.useState<Transaction[]>([]);
  const [filter, setFilter] = React.useState<{
    startDate: Dayjs | null;
    endDate: Dayjs | null;
  }>({
    startDate: null,
    endDate: null,
  });

  React.useEffect(() => {
    if (!filter.startDate && !filter.endDate) {
      return setRows(transactions);
    }
    const filtered = transactions.filter((transaction) => {
      const date = dayjs(transaction.date);

      return (
        (!filter.startDate || date.isAfter(filter.startDate)) &&
        (!filter.endDate || date.isBefore(filter.endDate))
      );
    });
    setRows(filtered);
  }, [transactions, filter]);
  return (
    <>
      <Box
        mb={1}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h6">交易記錄</Typography>
          <DateRangePicker value={filter} setValue={setFilter} />
          <IconButton
            size="small"
            color="primary"
            onClick={() => {
              setFilter({ startDate: null, endDate: null });
            }}
            sx={{
              border: 1,
              borderColor: "primary.light",
              "&:hover": {
                borderColor: "primary.main",
              },
            }}
          >
            <Replay fontSize="small" />
          </IconButton>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table
          size="small"
          sx={{ "& .MuiTableCell-root": { paddingY: 0, paddingX: 1 } }}
        >
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>時間</TableCell>
              <TableCell align="right">金額 ($)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <Box sx={{ py: 2 }}>沒有資料</Box>
                </TableCell>
              </TableRow>
            )}
            {rows.map((row) => (
              <Row key={row.id} row={row} />
            ))}
            <TableRow sx={{ height: 30 }}>
              <TableCell colSpan={2} align="right">
                總計
              </TableCell>
              <TableCell align="right">
                {rows.reduce((sum, row) => sum + row.total, 0)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TabTransaction;
